/**
 * Copyright (c) 2026 Farelanes LLC. All rights reserved.
 *
 * UI: Mobile Nav Bar Brand.
 */

import React, {useEffect, useState} from "react";
import {NavLink} from "react-router-dom";
import FarelanesCOPILOTLogo from "../../../assets/v3/title-my.farelanes-copilot.svg"
// import FarelanesCOPILOTLogo from "../../../assets/images/FL-CO-PILOT-logo.png"
import {useAuth0} from "@auth0/auth0-react";
import UserService from "../../../services/UserService";
import Ticker from "../../Ticker";
import { ROUTES } from "../../../config/routes";
import { redirectToLoginOnSessionError } from "../../../utils/sessionRedirect";

export const MobileNavBarBrand = ({handleClick}) => {

    const [subscriptionPlan, setSubscriptionPlan] = useState("");

    const {
        user,
        isAuthenticated,
        getAccessTokenSilently,
        loginWithRedirect,
        logout,
    } = useAuth0();


    useEffect(() => {
        async function getUsers() {
            try {
                const token = await getAccessTokenSilently();
                UserService.mySubscription(token).then(
                    response => {
                        setSubscriptionPlan(response.data)
                    },
                    error => {
                        redirectToLoginOnSessionError(error, loginWithRedirect);
                    }
                );
            } catch (err) {
                // ignore
            }
        }

        getUsers();
    }, []);

    return (
        <div onClick={handleClick} className="MobileNavBar__brand">
            <NavLink to={ROUTES.DASHBOARD}>
                <img
                    className="NavBar__logo"
                    src={FarelanesCOPILOTLogo}
                    alt="Farelanes logo"

                />
            </NavLink>
        </div>

    );
};
